import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { AxiosError } from 'axios';

import { axiosClient } from '@/lib/axios';

export const verifyPackagePromoCode = async ({
  code,
  companyID,
  packageID,
}: {
  companyID: number;
  packageID: number;
  code: string;
}): Promise<{ price: number }> => {
  const { data } = await axiosClient.put<{ price: number }>(
    `premium/${companyID}/packages/${packageID}/promo-code/apply`,
    {
      code,
    },
  );
  return data;
};

type UseVerifyPackagePromoCodeOptions = {
  config?: Partial<
    UseMutationOptions<
      { price: number },
      AxiosError<{ message: string }>,
      {
        companyID: number;
        packageID: number;
        code: string;
      }
    >
  >;
  postSuccess: () => void;
  handleAfterFailure: (code?: number) => void;
};

export const useVerifyPackagePromoCode = ({
  config,
  postSuccess,
  handleAfterFailure,
}: UseVerifyPackagePromoCodeOptions) => {
  const { notification: toaster } = App.useApp();
  return useMutation({
    onError: (error) => {
      toaster.error({
        message: 'Something Went Wrong',
        description: error.response?.data.message,
      });
      handleAfterFailure(error.response?.status);
    },
    onSuccess: () => {
      postSuccess();
    },
    ...config,
    mutationFn: verifyPackagePromoCode,
  });
};
